import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { IdleService } from '../services/idle.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService, private idle: IdleService) { }
  private readonly bypassAuth = [
    '/auth/login',
    '/auth/refresh',
    '/health'
  ];

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = localStorage.getItem('token');

    // Skip idle tracking for bypass routes
    const shouldBypassAuth = this.bypassAuth.some(route => request.url.includes(route));

    if (token) {
      // Reset idle timer for authenticated requests (except bypass routes)
      if (!shouldBypassAuth) {
        this.idle.bump('http-request');
      }

      // Check if the request body is FormData (file upload)
      const isFormData = request.body instanceof FormData;

      let headers = request.headers.set('Authorization', `Bearer ${token}`);

      // Only set Content-Type for non-FormData requests
      if (!isFormData) {
        headers = headers.set('Content-Type', 'application/json');
      }

      const cloned = request.clone({ headers });

      return next.handle(cloned).pipe(
        catchError((error: HttpErrorResponse) => {
          if (error.status === 401) {
            // Token is expired or invalid - redirect to login
            this.authService.logout();
          }
          return throwError(() => error);
        }),
      );
    }

    return next.handle(request);
  }
}